import React, { useState, useEffect, useMemo, useCallback, useReducer } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Table from '@components/table';
import { GetJson } from '@awp/helpers/fetchReact';
import { REST_API, SENSOR_PLACEMENT_CONFIG } from '@awp/constants';
import { BOOTSTRAP_BREAKPOINTS, checkBreakpoint } from '@awp/helpers/UIHelper';
import { debounce } from '@awp/helpers/Utils';
import { sortByNumericThenAlpha } from '@awp/helpers/sorter';
import { isValueEmpty, getUtcToLocalByFormat, convUtcIsoToApiDateString } from '@awp/helpers/utilsReact';
import { Button, Row, Col, Card, Form, Alert } from 'react-bootstrap';
import { format as formatDate } from 'date-fns';

import { currentElasticMinute } from '@stores/dashboardViewPageSlice';

const DetailMeasureTimeTable = ({ idx, sensorPlacement, mornType }) => {
  const [isMedium, setIsMedium] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
  const elasticMinute = useSelector(currentElasticMinute);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sort, setSort] = useState([{ id: 'CollectionEndTimeStamp', desc: true }]);

  useEffect(() => {
    if (isValueEmpty(sensorPlacement)) return;
    fetchData(); //children function of interest
  }, [sensorPlacement]);

  const fetchData = useCallback(() => {
    setLoading(true);
    if (
      !sensorPlacement ||
      isValueEmpty(sensorPlacement.StartUtcDateTime) ||
      isValueEmpty(sensorPlacement.EndUtcDateTime)
    )
      return;
    let url = REST_API.DASHBOARD_VIEWS;
    const apiUtcStartDate = convUtcIsoToApiDateString(sensorPlacement.StartUtcDateTime, 'yyyy-MM-dd-HH-mm');
    const apiUtcEndDate = convUtcIsoToApiDateString(sensorPlacement.EndUtcDateTime, 'yyyy-MM-dd-HH-mm');
    let strSubSegments = '-1';
    if (!isValueEmpty(sensorPlacement.SubSegments) && sensorPlacement.SubSegments.length > 0) {
      strSubSegments = sensorPlacement.SubSegments.join(',');
    }
    let isMixMode = false;
    if (SENSOR_PLACEMENT_CONFIG.MAPPINGS.includes(sensorPlacement.SensorTypeName)) isMixMode = true;
    let _mornType = 'completeness';
    if (!isValueEmpty(mornType)) _mornType = mornType;

    let collectionIntervalMins = 60;
    if (!isValueEmpty(sensorPlacement.CollectionIntervalMinutes))
      collectionIntervalMins = sensorPlacement.CollectionIntervalMinutes;

    url += `${apiUtcStartDate}/${apiUtcEndDate}/${sensorPlacement.IsSegmentActive}/${sensorPlacement.SegmentId}/${strSubSegments}/${isMixMode}/${elasticMinute.value}/${collectionIntervalMins}/${_mornType}`;
    GetJson(url)
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        setData(data);
      });
  }, [sensorPlacement, elasticMinute]);

  const TableColumns = useMemo(
    () => [
      {
        Header: 'Measured',
        accessor: 'CollectionEndTimeStamp',
        Cell: ({ value }) => {
          return getUtcToLocalByFormat(value, 'yyyy-MM-dd HH:mm');
        },
      },
      {
        Header: 'Available',
        accessor: 'AppCreateTimestamp',
        Cell: ({ value }) => {
          return getUtcToLocalByFormat(value, 'yyyy-MM-dd HH:mm');
        },
      },
    ],
    [isMedium],
  );
  return (
    <Table
      id={idx}
      columns={TableColumns}
      data={data}
      fetchData={() => {}}
      loading={loading}
      search={[]}
      filters={[]}
      dataTriggers={[]}
      sort={sort}
      setSort={setSort}
      defaultPageSize={5} //must be one of [5, 10, 25, 50, 100]
    />
  );
};
DetailMeasureTimeTable.propTypes = {
  idx: PropTypes.string,
  //requestDTO:PropTypes.object
};
export default DetailMeasureTimeTable;
